<div ng-style="{ height: '400px' }">
  <div class="u-textCenter u-margin-24-0">Finding your Introduction...</div>
  <app-progress-spinner></app-progress-spinner>
</div>
